import axiosClient from "api/axios_client.js";

const apiEmailDashboard = {
  getOverview: (range) => axiosClient.get("/email-management/email-dashboard/overview", { params: { range } }),
};

export default apiEmailDashboard;
